// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';

// utilities
import _ from 'lodash';

// components
import Search from '../../../../../common/components/Search';
import ContactTable from '../../../../../common/components/ContactTable';
// redux interactions
import * as asyncActionCreator from '../../../../../redux/actionCreators/async/contacts';
import * as adminStore from '../../../../../redux/actionCreators/sync/index';

@connect((state, props) => {
  const currentPage = state.admin.contacts.page || 0;
  const pageSize = state.admin.contacts.pageSize || 25;
  const skip = currentPage * pageSize;
  const limit = pageSize;

  return {
    contacts: state.admin.contacts.items,
    filters: state.admin.contacts.filters || {},
    searchTerms: state.admin.contacts.searchTerms || [],
    total: state.admin.contacts.total,
    pageSize,
    skip,
    currentPage,
    limit,
    staticData: state.staticData,
    route: {
      params: props.params,
    },
  };
})
export default class ContactManager extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    route: PropTypes.object,
    query: PropTypes.object,
    params: PropTypes.object,
    // expandCard: PropTypes.func.isRequired,
    contacts: PropTypes.any,
    contactGroups: PropTypes.object,
    staticData: PropTypes.object,
    selectedContactId: PropTypes.string,
    tableLayout: PropTypes.bool,
    minWidth: PropTypes.string,
    searchContacts: PropTypes.func,
    filters: PropTypes.object,
    searchTerms: PropTypes.array,
    total: PropTypes.number,
    pageSize: PropTypes.number,
    currentPage: PropTypes.number,
  }

  state = {
    tableLayout: _.get(this.props, 'tableLayout', false),
  }

  componentDidMount() {
    this.props.searchContacts(this.props.searchTerms, this.props.filters, this.props.skip, this.props.limit); // keep current page
  }

  componentDidUpdate(prevProps) {
    // separate filters from sorting
    const filters = _.omit(prevProps.filters, ['order']);
    const newFilters = _.omit(this.props.filters, ['order']);

    const sortBy = _.pick(prevProps.filters, ['order']);
    const newSortBy = _.pick(this.props.filters, ['order']);

    const skip = this.props.skip || 0;
    const limit = this.props.limit || 25;

    // check if filters, sorting, or search terms have changed
    if (!_.isEqual(sortBy, newSortBy)) {
      this.props.searchContacts(
        this.props.searchTerms,
        {...newFilters, ...newSortBy, skip, limit}); // keep current page
    }

    if (!_.isEqual(filters, newFilters)) {
      this.props.searchContacts(this.props.searchTerms, {...newFilters, ...newSortBy});
    }

    if (!_.isEqual(prevProps.searchTerms, this.props.searchTerms)) {
      this.props.searchContacts(this.props.searchTerms, {...newFilters});
    }
  }

  onPageChange(page) {
    const {
      pageSize,
      searchTerms = [],
      filters = {},
    } = this.props;

    const skip = page * pageSize;

    this.props.dispatch(asyncActionCreator.goToPage(skip, pageSize, filters, searchTerms))
    .then(() => {
      this.props.dispatch(adminStore.goToContactsPage(page));
    });

  }

  onTermChange(terms = []) {
    this.props.dispatch(adminStore.updateContactsTableSearchTerms(terms));
    this.resetToPageOne();
  }

  onSort(fields) {
    this.props.dispatch(adminStore.updateContactsTableFilters({...this.props.filters, ...fields}));
  }

  resetToPageOne() {
    this.props.dispatch(adminStore.goToContactsPage(0));
  }

  updateContactsFilter(event, key, filterName) {
    // get current filters
    let newFilters = _.cloneDeep(this.props.filters) || {};

    // set new filter
    if (key < 0) {
      newFilters = _.omit(newFilters, filterName);
    }
    else {
      const filterValue = !_.isUndefined(key) ?
        ( _.isNull(key) ? ((filterName === 'clientAdvisorId') ? 'null' : null) : key) :
        (_.get(event, 'target.value') || 0)
      ;

      _.set(newFilters, filterName, filterValue);
    }

    // dispatch action to update filters in contacts store
    this.props.dispatch(adminStore.updateContactsTableFilters(_.omitBy(newFilters, _.isNil)));
    this.resetToPageOne();
  }

  handleTableToggle = () => {
    this.setState({tableLayout: !this.state.tableLayout});
  }

  render() {
    return (
      <ul className='contact-dashboard-contact-manager'>
        <div className='contact-header'>
          <h1>CONTACTS</h1>
          <Search
            onTermChange={::this.onTermChange}
            defaultValues={this.props.searchTerms}
            baseUrl='/admin/contacts'
          />
        </div>
        <ContactTable
          useContactTypeDropdown
          contactLink
          companyLink
          showFilters
          contacts={this.props.contacts}
          updateContactsFilter={::this.updateContactsFilter}
          onSort={::this.onSort}
          className='full-width'
          minWidth={this.props.minWidth}
          location={this.props.location}
          filters={this.props.filters}
          columns={['CardName', 'Title', 'Company', 'Phone', 'ContactDate', 'Email', 'Status', 'JobCounts', 'Tags']}
          total={this.props.total}
          currentPage={this.props.currentPage}
          pageSize={this.props.pageSize}
          handlePageSkip={::this.onPageChange}
        />
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Dashboard/ContactManager/index.js